import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
import api from "./api/api_modules"  // axios封装
import './assets/css/global.less'
import './assets/css/fonts.css'
import until from './assets/js/until'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
// import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
// import { BarChart, PieChart, LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
// import {
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   LegendComponent,
//   ToolboxComponent,
//   DataZoomComponent,
//   TransformComponent
// } from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
// import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
// import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
// echarts.use([
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   LegendComponent,
//   ToolboxComponent,
//   DataZoomComponent,
//   TransformComponent,
//   BarChart,
//   PieChart,
//   LineChart,
//   LabelLayout,
//   UniversalTransition,
//   CanvasRenderer
// ]);
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole);

Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.prototype.$until = until.methods

Vue.use(ElementUI);

// Vue.use(Viewer);//图片预览
// console.log(fixElSelectIOS,ElSelect,Vue.options.components['el-select']?.mixins)
// debugger
router.beforeEach((to, from, next) => {
  // console.log(to, from)
  // console.log(store.getters.menuItems)
  (store.getters.menuItems || []).map(item => {

    if (item && (item.path == to.path || JSON.stringify(item).indexOf(`"${to.path}"`) > -1)) {
      store.commit('setCurrentModule', item.module);
    }
  })
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 在 main.js 中添加此全局 mixin
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

Vue.mixin({
  mounted() {
    // 仅针对 iOS 设备上的 filterable el-select
    if (!isIOS() || this.$options.name !== 'ElSelect' || !this.filterable) return;

    // 创建修复处理函数
    const fixHandler = (e) => {
      // 确保是点击在输入区域
      const input = this.$el.querySelector('.el-input__inner');
      if (!input || !input.contains(e.target)) return;
      
      // 关键修复步骤 1: 在用户手势事件流中同步移除 readonly
      if (input.readOnly) {
        input.readOnly = false;
      }
      
      // 关键修复步骤 2: 在同一个事件流中同步聚焦
      input.focus();
      
      // 额外保障: 如果聚焦失败（罕见情况），使用 setTimeout 重试
      setTimeout(() => {
        if (document.activeElement !== input) {
          input.focus();
        }
      }, 50);
    };

    // 保存处理函数以便销毁时清理
    this._iosSelectFixHandler = fixHandler;
    
    // 关键修复步骤 3: 使用捕获阶段确保在 el-select 内部逻辑前执行
    this.$el.addEventListener('touchend', fixHandler, true);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    if (this._iosSelectFixHandler) {
      this.$el?.removeEventListener('touchend', this._iosSelectFixHandler, true);
      delete this._iosSelectFixHandler;
    }
  }
});

// Viewer.setDefaults({
//   'inline': false,
//   'button': true, //右上角按钮
//   "navbar": true, //底部缩略图
//   "title": true, //当前图片标题
//   "toolbar": true, //底部工具栏
//   "tooltip": true, //显示缩放百分比
//   "movable": true, //是否可以移动
//   "zoomable": true, //是否可以缩放
//   "rotatable": true, //是否可旋转
//   "scalable": true, //是否可翻转
//   "transition": true, //使用 CSS3 过度
//   "fullscreen": true, //播放时是否全屏
//   "keyboard": true, //是否支持键盘
//   "url": "data-source",
//   ready: function (e) {
//     //console.log(e.type,'组件以初始化');
//   },
//   show: function (e) {
//     //console.log(e.type,'图片显示开始');
//   },
//   shown: function (e) {
//     //console.log(e.type,'图片显示结束');
//   },
//   hide: function (e) {
//     //console.log(e.type,'图片隐藏完成');
//   },
//   hidden: function (e) {
//     //console.log(e.type,'图片隐藏结束');
//   },
//   view: function (e) {
//     //console.log(e.type,'视图开始');
//   },
//   viewed: function (e) {
//     //console.log(e.type,'视图结束');
//   },
//   zoom: function (e) {
//     //console.log(e.type,'图片缩放开始');
//   },
//   zoomed: function (e) {
//     //console.log(e.type,'图片缩放结束');
//   }
// });